/** @jsxRuntime classic */
/** @jsx jsx */
import { useLayoutEffect } from 'react';

import { setUser } from '../ducks/user';
import { getCachedAuthData } from '../selectors';

const useCachedAuth = dispatch => {
  const isDev = import.meta.env.MODE === 'development';
  // A layout effect, so the cached user is in the store before any page's
  // (passive) data-fetching effects run; they use it to skip fetching your
  // own profile while /users/me is loading it (see getIsOwnProfilePending).
  useLayoutEffect(() => {
    const storage = window.localStorage;
    if (!storage) {
      return;
    }
    const data = getCachedAuthData();
    if (!data) {
      return;
    }
    if (isDev) {
      // eslint-disable-next-line
      console.info('Using cached auth data:', data);
    }
    dispatch(setUser({ ...data, _stale: true }));
  }, []);
};

export default useCachedAuth;
